import { render, staticRenderFns } from "./landingpage.html?vue&type=template&id=7b1e44ae&scoped=true&"
import script from "./landingpage.js?vue&type=script&lang=js&"
export * from "./landingpage.js?vue&type=script&lang=js&"
import style0 from "./landingpage.scss?vue&type=style&index=0&id=7b1e44ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1e44ae",
  null
  
)

export default component.exports